<template>
  <div>
    <Layout ref="layoutRef" :selectedOption="1" />
    <h5>Asistente para el registro de Médicos</h5>
    <div style="display: flex; justify-content: space-between; background-color: #f0f0f0; padding: 10px; border-radius: 5px;">
      <h4>Paso 1: Datos de la persona </h4>
<!--
      <h4 style="margin: 0;">
        <span class="btn btn-success"><b>1</b></span>
        <span class="btn btn-secondary">2</span>
        <span class="btn btn-secondary">3</span>
      </h4>
-->
    </div>
    <hr>
    <!-- Modal -->
    <div class="modal-dialog modal-xl">
      <div class="modal-content">
        <h5 class="modal-title" id="exampleModalLabel">
          <i class="fa fa-user-plus"></i> {{titulo}}</h5>
        <div class="modal-body">
          <div class="row">
            <!-- Columna de la imagen -->
            <div class="col-md-3">
              <img src="../../assets/images/wizardCita/paciente_cita_01.png" alt="Imagen" :style="estiloImagen" />
            </div>
            <!-- Columna del formulario -->
            <div class="col-md-9">
              <form>
        <div class="modal-body">
            <div class="mb-3" v-if="btnEditar">
              <div class="row">
                <div class="col-2">
                  <label for="idPersona" class="form-label">IdPersona</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="idPersona" name="idPersona" v-model="datoPersona.idPersona" disabled>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
<!--
                <div class="col-2">
                  <label for="tipoPersona" class="form-label">TipoPersona</label>
                </div>
                <div class="col-4">
                  <select class="form-control" id="tipoPersona" name="tipoPersona" v-model="datoPersona.tipoPersona" required>
                      <option value="N">Natural</option>
                      <option value="J">Juridica</option>
                  </select>
                </div>
-->                
              </div>
            </div>
<!-- Botón Lista de Valores  Tipo Iden -->
            <div class="mb-3">
<!--
                <input type="hidden" class="form-control" id="idTipoIden" name="idTipoIden" v-model="datoPersona.idTipoIdenNombre"
                disabled>
-->
                <div class="row">
<!--
                  <div class="col-2">
                    <label for="idTipoIden" class="form-label"> Tipo Iden</label>
                  </div>
                  <div class="col-4">
                    <input type="text" class="form-control" id="tipoIden" name="tipoIden" v-model="datoPersona.tipoIdenNombre" disabled>
                  </div>
                  <div class="col-1">
                    <button type="button" class="btn btn-light" data-bs-toggle="modal" data-bs-target="#ModalTipoIdenLOV"
                     title="Buscar Tipos de Identificación">
                      <i class="material-icons" style="font-size:24px;color:blue; cursor: pointer;">manage_search</i>
                    </button>
                  </div>
-->

                  <div class="col-2">
                    <label for="idTipoIden" class="form-label"> Tipo Iden</label>
                  </div>
                  <div class="col-4">

                  <select class="form-control" id="idTipoIden" name="idTipoIden" v-model="datoPersona.idTipoIden" @change="handleChange01">
                    <option v-for="tipoIden in tiposIden" :key="tipoIden.idTipoIden" :value="tipoIden.idTipoIden">{{ tipoIden.nombre }}</option>
                  </select>

<!--
                    <input type="text" class="form-control" id="tipoIden" name="tipoIden" v-model="datoPersona.tipoIdenNombre" disabled>
-->
                  </div>



                  <div class="col-2">
                    <label for="documento" class="form-label">Documento</label>
                  </div>
                  <div class="col-3">
                    <input type="text" class="form-control" id="documento" name="documento" v-model="datoPersona.documento" style='text-transform:uppercase' required>
                  </div>
                  <div class="col-1">
                    <button type="submit" class="btn btn-primary" @click.prevent="consultarRC" title="Buscar registros">
                      <i class="material-icons" style="font-size:20px;color:white; cursor: pointer;">search</i>
                    </button>
                  </div>
                </div>
            </div>
<!-- Botón Lista de Valores  Tipo Iden -->
<!-- Botón Lista de Valores  Localidad -->
            <div class="mb-3">
                <input type="hidden" class="form-control" id="idLocalidad" name="idLocalidad" v-model="datoPersona.idLocalidad"
                disabled>
                <div class="row">

                  <div class="col-2">
                    <label for="idLocalidad" class="form-label"> Localidad</label>
                  </div>
                  <div class="col-4">
<!--                    
                    <input type="text" class="form-control" id="localidad" name="localidad" v-model="datoPersona.localidadNombre" disabled>
-->
                    <div class="input-group">
                      <input type="text" class="form-control" v-model="searchText" @input="filterLocalidades" placeholder="Buscar localidad...">
                      <button class="btn btn-outline-secondary dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                        <i class="fa fa-search"></i>
                      </button>
                      <ul class="dropdown-menu dropdown-menu-end" style="max-height: 200px; overflow-y: auto;">
                        <li v-for="localidad in filteredLocalidades" :key="localidad.idLocalidad">
                          <a class="dropdown-item" href="#" @click="selectLocalidad(localidad)">
                            {{ localidad.nombre }}
                          </a>
                        </li>
                      </ul>
                    </div>

                  </div>
<!--
                  <div class="col-1">
                    <button type="button" class="btn btn-light" data-bs-toggle="modal" data-bs-target="#ModalLocalidadLOV"
                     title="Buscar Localidades">
                      <i class="material-icons" style="font-size:24px;color:blue; cursor: pointer;">manage_search</i>
                    </button>
                  </div>
-->

                  <div class="col-2">
                    <label for="fechaNac" class="form-label">Fecha Nac.</label>
                  </div>
                  <div class="col-4">
                    <input type="date" class="form-control" id="fechaNac" name="fechaNac" v-model="formattedFechaNac" required>
                  </div>
                </div>
            </div>
<!-- Botón Lista de Valores  Localidad -->
<!-- Botón Lista de Valores  Estado Civil -->
            <div class="mb-3">
<!--
                <input type="hidden" class="form-control" id="idEstadoCivil" name="idEstadoCivil" v-model="datoPersona.idEstadoCivil"
                disabled>
-->
                <div class="row">

                  <div class="col-2">
                    <label for="idEstadoCivil" class="form-label"> Estado Civil</label>
                  </div>
                  <div class="col-4">
                    <select class="form-control" id="idEstadoCivil" name="idEstadoCivil" v-model="datoPersona.idEstadoCivil" @change="handleChange02">
                      <option v-for="estadoCivil in estadosCiviles" :key="estadoCivil.idEstadoCivil" :value="estadoCivil.idEstadoCivil">{{ estadoCivil.nombre }}</option>
                    </select>
<!--
                    <input type="text" class="form-control" id="estadoCivil" name="estadoCivil" v-model="datoPersona.estadoCivilNombre" disabled>
-->
                  </div>
<!--
                  <div class="col-1">
                    <button type="button" class="btn btn-light" data-bs-toggle="modal" data-bs-target="#ModalEstadoCivilLOV"
                     title="Buscar Estado Civil">
                      <i class="material-icons" style="font-size:24px;color:blue; cursor: pointer;">manage_search</i>
                    </button>
                  </div>
-->

                  <div class="col-2">
                    <label for="telefono" class="form-label">Teléfono</label>
                  </div>
                  <div class="col-4">
                    <input type="text" class="form-control" id="telefono" name="telefono" v-model="datoPersona.telefono" required>
                  </div>
                </div>
            </div>
<!-- Botón Lista de Valores  Estado Civil -->
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="primerNombre" class="form-label">Pri. Nombre</label>
                </div>
                <div class="col-4">
                  <input type="text" class="form-control" id="primerNombre" name="primerNombre" v-model="datoPersona.primerNombre" style='text-transform:uppercase' required>
                </div>
                <div class="col-2">
                  <label for="segundoNombre" class="form-label">Seg. Nombre</label>
                </div>
                <div class="col-4">
                  <input type="text" class="form-control" id="segundoNombre" name="segundoNombre" v-model="datoPersona.segundoNombre" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="primerApellido" class="form-label">Pri. Apellido</label>
                </div>
                <div class="col-4">
                  <input type="text" class="form-control" id="primerApellido" name="primerApellido" v-model="datoPersona.primerApellido" style='text-transform:uppercase' required>
                </div>
                <div class="col-2">
                  <label for="segundoApellido" class="form-label">Seg. Apellido</label>
                </div>
                <div class="col-4">
                  <input type="text" class="form-control" id="segundoApellido" name="segundoApellido" v-model="datoPersona.segundoApellido" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="direccion" class="form-label">Dirección</label>
                </div>
                <div class="col-10">
                  <input type="text" class="form-control" id="direccion" name="direccion" v-model="datoPersona.direccion" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="email" class="form-label">E-mail</label>
                </div>
                <div class="col-6">
                  <input type="text" class="form-control" id="email" name="email" v-model="datoPersona.email" required>
                </div>
                <div class="col-1">
                </div>
                <div class="col-1">
                  <label for="sexo" class="form-label">Sexo</label>
                </div>
                <div class="col-2">
                  <select class="form-control" id="sexo" name="sexo" v-model="datoPersona.sexo" required>
                      <option value="F">Femenino</option>
                      <option value="M">Masculino</option>
                  </select>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-8">
                </div>
                <div class="col-2">
                  <label for="idTipoSangre" class="form-label">Tipo sangre</label>
                </div>
                <div class="col-2">
                  <select class="form-control" id="idTipoSangre" name="idTipoSangre" v-model="datoPersona.idTipoSangre">
                    <option v-for="tipoSangre in tiposSangre" :key="tipoSangre.idTipoSangre" :value="tipoSangre.idTipoSangre">{{ tipoSangre.nombre }}</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
        </form>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="submit" class="btn btn-light" @click.prevent="guardarPersona" v-if="btnCrear" title="Continuar" style="display: flex; align-items: center; justify-content: center;">
            Siguiente<span class="material-symbols-outlined" style="font-size:32px;color:blue; cursor: pointer;">chevron_right</span>
          </button>
        </div>
      </div>
    </div>
    <!-- Lista de Valores  Empresa -->
    <EmpresaLOV @DatosEmpresa="GetDataEmpresaLOV($event)" />
    <!-- Lista de Valores  Tipo Iden -->
    <TipoIdenLOV @DatosTipoIden="GetDataTipoIdenLOV($event)" />
    <!-- Lista de Valores  Localidad -->
    <LocalidadLOV @DatosLocalidad="GetDataLocalidadLOV($event)" />
    <!-- Lista de Valores  Estado Civil -->
    <EstadoCivilLOV @DatosEstadoCivil="GetDataEstadoCivilLOV($event)" />
    <Footer />
  </div>
</template>
<script>
import Layout from '@/components/Layout.vue'
import Footer from '@/components/Footer.vue'
import dateFormat from '@/modules/dateFormat.js';
import { validarForm } from '@/modules/validacionesForms.js'

import EmpresaLOV from '../../components/lovs/EmpresaLOV.vue'
import TipoIdenLOV from '../../components/lovs/TipoIdenLOV.vue'
import LocalidadLOV from '../../components/lovs/LocalidadLOV.vue'
import EstadoCivilLOV from '../../components/lovs/EstadoCivilLOV.vue'

import api from "@/services/api";
import { alertaError } from '@/utils/alertas';
import * as $ from 'jquery';
window["$"] = $;
window["jQuery"] = $;
export default {
  components : {
    Layout, Footer
, EmpresaLOV
, TipoIdenLOV
, LocalidadLOV
, EstadoCivilLOV
  },
  data () {
    return {
      personas : [],
      datoPersona : {},
      nombreBusqueda: '',
      titulo: '',
      btnCrear: true,
      btnEditar: false,
      modalWindow: true,
      p_idPersona: 0,
      showTable:'mediopers', 
      tiposIden: [],
      estadosCiviles: [],
      tiposSangre: [],
      localidades: [],
      filteredLocalidades: [],
      searchText: '',      
      showModalHelp: false,
      estiloImagen: {
        width: "200px",
        height: "200px"
      }
    }
  },
  computed: {
    formattedFechaNac: {
      get() {
        if (!this.datoPersona.fechaNac) return '';
        const date = new Date(this.datoPersona.fechaNac);
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
      },
      set(value) {
        const date = new Date(value);
        date.setMinutes(date.getMinutes() + date.getTimezoneOffset()); // Ajuste para zona horaria
        this.datoPersona.fechaNac = date.toISOString();
      }
    }
  },
  mounted () {
//    alert('empresa: '+window.sessionStorage.getItem("idEmpresa")+'; suscripcion: '+window.sessionStorage.getItem("idSuscripcion"));
    this.p_idPersona = this.$route.params.p_idpersona
    if(this.p_idPersona > 0)
      this.getData()
    this.$refs.layoutRef.toggleProcesos()
    this.$refs.layoutRef.toggleReportes()
    this.$refs.layoutRef.toggleParametros()
    this.$refs.layoutRef.toggleAyuda()
    this.fetchTiposIden()
    this.fetchEstadosCiviles()
    this.fetchLocalidades()
    this.fetchTiposSangre();
  },
  methods : {
    getFormattedDate(date) {
      return dateFormat.getFormattedDate(date);
    },
   getData() {
      api.get('/vwpersonas/'+this.p_idPersona)
        .then(response => {
          this.datoPersona = response.data;
          this.searchText = this.datoPersona.localidadNombre;
        })
        .catch(error => {
         console.error('Error al obtener datos de la persona:', error);
        });
    },
validarForm(){
      const requiredFields = [
        'idTipoIden'
        ,'idLocalidad'
        ,'idEstadoCivil'
        ,'documento'
        ,'primerNombre'
        ,'segundoNombre'
        ,'primerApellido'
        ,'segundoApellido'
        ,'fechaNac'
        ,'direccion'
        ,'telefono'
        ,'sexo'
        ,'email'
      ];
      const requiredFieldsText = [
        '"Tipo de Identificación"',
        '"Localidad"',
        '"Estado Civil"',
        '"Documento"',
        '"Primer Nombre"',
        '"Segundo Nombre"',
        '"Primer Apellido"',
        '"Segundo Apellido"',
        '"Fecha de Nacimiento"',
        '"Dirección"',
        '"Teléfono"',
        '"Sexo"',
        '"Correo Electrónico"'
      ];
      if (this.datoPersona.documento.length !== 10) {
        alert('El número de cédula debe tener 10 dígitos.');
        return;
      }
      return validarForm(this.datoPersona, requiredFields, requiredFieldsText);
    },
    async guardarPersona(){
      if(this.validarForm() === 1){
        try {
          this.datoPersona.idEmpresa = window.sessionStorage.getItem("idEmpresa");

//          alert("Localidad: "+this.datoPersona.idLocalidad)
//          alert("EstadoCivil: "+this.datoPersona.idEstadoCivil)         
//          alert("TipoIden: "+this.datoPersona.idTipoIden)
/*
          alert("primerNombre: "+this.datoPersona.primerNombre)
          alert("segundoNombre: "+this.datoPersona.segundoNombre)
          alert("primerApellido: "+this.datoPersona.primerApellido)
          alert("segundoApellido: "+this.datoPersona.segundoApellido)
*/
          await api.post('/personas', this.datoPersona).then(response=>{
                              this.personas=response.data;
                              this.datoPersona.idPersona = this.personas.idPersona;
                              //alert("hola: "+this.personas.idPersona);
                            });
          this.$router.push('/medico02/'+this.personas.idPersona)
        } catch (error) {
          if (error.response && error.response.data) {
            // Captura el mensaje de error enviado por el backend
            const errorMessage = error.response.data.message || "Ocurrió un error, intente de nuevo.";
            alertaError(errorMessage);
          } else {
            alertaError('Ocurrió un error, intente de nuevo.');
          }
        }
      }
    },
    fetchTiposIden() {
      fetch('http://localhost:8080/api/v1/vwtipoidens')
        .then(response => response.json())
        .then(data => {
          this.tiposIden = data;
        })
        .catch(error => {
          console.error('Error fetching tiposIden:', error);
        });
    },
    handleChange01() {
      this.$emit('tipoIdenSelected', this.selectedTipoIden);
    },
    fetchEstadosCiviles() {
      fetch('http://localhost:8080/api/v1/vwestadocivils')
        .then(response => response.json())
        .then(data => {
          this.estadosCiviles = data;
        })
        .catch(error => {
          console.error('Error fetching estados civiles:', error);
        });
    },
    fetchTiposSangre() {
      fetch('http://localhost:8080/api/v1/vwtiposangres')
        .then(response => response.json())
        .then(data => {
          this.tiposSangre = data;
        })
        .catch(error => {
          console.error('Error fetching estados civiles:', error);
        });
    },
    handleChange02() {
      this.$emit('estadoCivilSelected', this.selectedEstadoCivil);
    },
    fetchLocalidades() {
      fetch('http://localhost:8080/api/v1/vwlocalidads')
        .then(response => response.json())
        .then(data => {
          this.localidades = data;
          this.filteredLocalidades = data;
        })
        .catch(error => {
          console.error('Error fetching localidades:', error);
        });
    },
    filterLocalidades() {
      this.filteredLocalidades = this.localidades.filter(localidad =>
        localidad.nombre.toLowerCase().includes(this.searchText.toLowerCase())
      );
    },
    selectLocalidad(localidad) {
      this.searchText = localidad.nombre;
      // Asignar el ID de la localidad seleccionada a datoPersona.idLocalidad
      this.datoPersona.idLocalidad = localidad.idLocalidad;
//      this.$emit('update:datoPersona', { ...this.datoPersona, idLocalidad: localidad.idLocalidad });
    },   
//    Lista de Valores  Empresa
    GetDataEmpresaLOV(data) {
      this.datoPersona.idEmpresa = data.idEmpresa;
      this.datoPersona.empresa = data.nombre;
    },
//    Lista de Valores  Tipo Iden
    GetDataTipoIdenLOV(data) {
      this.datoPersona.idTipoIden = data.idTipoIden;
      this.datoPersona.tipoIden = data.nombre;
    },
//    Lista de Valores  Localidad
    GetDataLocalidadLOV(data) {
      this.datoPersona.idLocalidad = data.idLocalidad;
      this.datoPersona.localidad = data.nombre;
    },
//    Lista de Valores  Estado Civil
    GetDataEstadoCivilLOV(data) {
      this.datoPersona.idEstadoCivil = data.idEstadoCivil;
      this.datoPersona.estadoCivil = data.nombre;
    },
    consultarRC(){
      if (this.datoPersona.documento === null || this.datoPersona.documento === undefined || this.datoPersona.documento.trim() === ""){
        alertaError('Ingrese el número de documento para realizar la consulta.');
      }
      else{
        this.searchText = 'AZUAY';
        this.datoPersona.idTipoIden = 1;
        this.datoPersona.idLocalidad = 1;
        this.datoPersona.idEstadoCivil = 1;
        this.datoPersona.primerNombre = 'PRIMER NOMBRE';
        this.datoPersona.segundoNombre = 'SEGUNDO NOMBRE';
        this.datoPersona.primerApellido = 'PRIMER APELLIDO';
        this.datoPersona.segundoApellido = 'SEGUNDO APELLIDO';
        this.datoPersona.fechaNac = '2024-05-23';
        this.datoPersona.direccion = 'DIRECCION';
        this.datoPersona.telefono= '1234567890';
        this.datoPersona.tipoPersona = 'N';
        this.datoPersona.sexo = 'M';
        this.datoPersona.email = 'paciente001@correo.com';
        this.datoPersona.fechaReg = '2024-05-23';
        this.datoPersona.estado = 1;
      }
    }
  },
}
</script>